import React, { Fragment, Component } from "react";
import GlobalPromoModal from "./GlobalPromoModal";
import moment from 'moment';
import {  withRouter } from "react-router-dom";

class GlobalPromo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      promoModal: false,
      promoHideButton: false,
    }

    this.closePromoModal = this.closePromoModal.bind(this);
    this.openPromoModal = this.openPromoModal.bind(this);
  }

  componentDidMount() {
    if (this.props.location.pathname === '/') {
      this.setState({
        promoModal: true
      })
    }
    if (this.props.location.pathname.toLowerCase().startsWith('/promotion/')) {
      this.setState({
        promoHideButton: true
      })
    }
  }
  openPromoModal() {
    this.setState({
      promoModal: true
    })
  }

  closePromoModal() {
    this.setState({
      promoModal: false
    })
  }
render() {
  const {promoData} = this.props;
  let buttonStyle = {};
  if (this.state.promoHideButton) { buttonStyle = {display: 'none'} } else { buttonStyle = {display: 'flex'} };
  return <Fragment>
    <div className="promo__button" onClick={this.openPromoModal} style={buttonStyle} >
      <div className="text-1">Promo</div>
      <div className="text-2">ends {moment(promoData.expiry_date).format("M/D")}</div>
    </div>
    <GlobalPromoModal open={this.state.promoModal} closeModal={this.closePromoModal} promoData={promoData} />
  </Fragment>
  }
}

export default withRouter(GlobalPromo);


// WEBPACK FOOTER //
// ./src/components/global-promo/GlobalPromo.js